import API from "../services/api";
import * as ACTION_TYPES from "../types";

export const getUsers = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch({ type: ACTION_TYPES.REQUEST });
    API.getData("users")
      .then((res) => {
        dispatch({ type: ACTION_TYPES.GET_USERS, data: res.data });
        dispatch({ type: ACTION_TYPES.DONE });
        resolve(res.data);
      })
      .catch((err) => {
        reject();
      });
  });
};

export const resetUsers = () => (dispatch) => {
  dispatch({ type: ACTION_TYPES.RESET_USERS });
};

export const addUser = (user) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API.postData("users", user)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addUserToPool = (poolId, pool) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API.putData(`pools/${poolId}`, pool)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject();
      });
  });
};

export const deleteUserFromPool = (poolId, pool) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API.putData(`pools/${poolId}`, pool)
      .then((res) => {
        resolve();
      })
      .catch((err) => {
        reject();
      });
  });
};

export const deleteUser = (userId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API.deleteData(`users/${userId}`)
      .then((res) => {
        dispatch({ type: ACTION_TYPES.DELETE_USER, id: userId });
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const removeUser = (userId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API.deleteData(`users/removeUser/${userId}`)
      .then((res) => {
        dispatch({ type: ACTION_TYPES.DELETE_USER, id: userId });
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getUserByID = (_id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API.getData(`users/${_id}`)
      .then((res) => {
        dispatch({ type: ACTION_TYPES.GET_USER_BY_ID, data: res.data });
        resolve(res.data);
      })
      .catch((err) => {
        reject();
      });
  });
};
export const getUser = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    API.getData(`users/userById`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject();
      });
  });
};
export const getUserByPhone = (phone) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API.getData(`users/phone/${phone}`)
      .then((res) => {
        dispatch({ type: ACTION_TYPES.GET_USER_BY_ID, data: res.data });
        resolve(res.data);
      })
      .catch((err) => {
        reject();
      });
  });
};
export const getUserByEmail = (email) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API.getData(`users/email/${email}`)
      .then((res) => {
        dispatch({ type: ACTION_TYPES.GET_USER_BY_ID, data: res.data });
        resolve(res.data);
      })
      .catch((err) => {
        reject();
      });
  });
};

export const editUser = (_id, user) => (dispatch) => {
  return new Promise((resolve, reject) => {
    user.phone = user.phone.trim();
    user.phone = user.countryCode + " " + user.phone;
    API.putData(`users/${_id}`, user)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject();
      });
  });
};

export const getUsersByQuery = (query) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API.getData(`users?${query}`)
      .then((res) => {
        dispatch({ type: ACTION_TYPES.GET_USER_BY_QUERY, data: res.data });

        resolve(res.data);
      })
      .catch((err) => {
        reject();
      });
  });
};

export const getFilteredUsers = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    API.getData(`users/projectUsers`)
      .then((res) => {
        dispatch({ type: ACTION_TYPES.GET_FILTERED_USERS, data: res.data });

        resolve(res.data);
      })
      .catch((err) => {
        reject();
      });
  });
};

export const changePassword = (value) => (dispatch) => {
  const data = {
    emailOrPhone: value.email,
    newPassword: value.password
  }
  return new Promise((resolve, reject) => {
    dispatch({ type: ACTION_TYPES.PASSWORD_CHANGE_REQUEST });
    API.postData("users/setpassword", data)
      .then((res) => {
        dispatch({ type: ACTION_TYPES.PASSWORD_CHANGE_SUCCESS });
        resolve(res);
      })
      .catch((err) => {
        dispatch({ type: ACTION_TYPES.PASSWORD_CHANGE_FAIL });
        reject(err);
      });
  });
};

export const sendVerificationCode = (phone) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch({ type: ACTION_TYPES.VERIFICATION_CODE_REQUEST });
    API.postData(`users/sendVerificationCode`, { phone })
      .then((res) => {
        dispatch({ type: ACTION_TYPES.VERIFICATION_CODE_SUCCESS });
        resolve(res);
      })
      .catch((err) => {
        dispatch({ type: ACTION_TYPES.VERIFICATION_CODE_FAIL });
        reject(err);
      });
  });
};

export const verify = (verificationCode, phone) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch({ type: ACTION_TYPES.VERIFY_REQUEST });
    API.postData(`users/verify`, { verificationCode, phone })
      .then((res) => {
        dispatch({ type: ACTION_TYPES.VERIFY_SUCCESS });
        resolve(res);
      })
      .catch((err) => {
        dispatch({ type: ACTION_TYPES.VERIFY_FAIL });
        reject(err);
      });
  });
};

export const authorize = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch({ type: ACTION_TYPES.GET_AUTHORIZED_PROJECT_AND_USER });
    API.postData(`users/authorize`)
      .then((res) => {
        const { user, project } = res.data;
        dispatch({ type: ACTION_TYPES.AUTHORIZE_SUCCESS });
        dispatch({
          type: ACTION_TYPES.SET_AUTHORIZED_PROJECT_AND_USER,
          payload: { user, project }
        });
        resolve(res.data);
      })
      .catch((err) => {
        dispatch({ type: ACTION_TYPES.AUTHORIZE_FAIL });
        dispatch({ type: ACTION_TYPES.AUTHORIZE_PROJECT_AND_USER_FAIL, payload: err });
        reject(err);
      });
  });
};
export const confirmByLink = (userId, verificationId) => {
  return new Promise((resolve, reject) => {
    API.postData(`users/confirmByLink`, { userId, verificationId })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const logout = () => (dispatch) => {
  dispatch({ type: ACTION_TYPES.LOGOUT });
};

export const addUserToProject = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {

    API.postData(`users/addUserToProject`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        dispatch({ type: ACTION_TYPES.ERROR, data: err });
        reject();
      });
  });
};
export const sendPartnerIdMail = (userId, projectId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API.getData(`users/sendPartnerIdMail/?userId=${userId}&projectId=${projectId}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        dispatch({ type: ACTION_TYPES.ERROR, data: err });
        reject();
      });
  });
};

export const setSessionTimedOut = (sessionTimedOut = false) => (dispatch) => {
  dispatch({ type: ACTION_TYPES.SESSION_TIMED_OUT, data: sessionTimedOut });
}

export const resetPassword = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API.postData(`users/resetPassword`, { emailOrPhone: data })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        console.log("errr", err);
        dispatch({ type: ACTION_TYPES.ERROR, data: err });
        reject(err);
      });
  });
};

export const setPassword = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API.postData(`users/setpassword`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        console.log("errr", err);
        dispatch({ type: ACTION_TYPES.ERROR, data: err });
        reject(err);
      });
  });
};

